/* eslint-disable comma-dangle */
import React, { useEffect, useState } from 'react'
import Masonry, { ResponsiveMasonry } from 'react-responsive-masonry'
import { useSelector, useDispatch } from 'react-redux'
import { Grid } from '@material-ui/core/'
import { useHistory, useLocation } from 'react-router-dom'
import { Menu } from 'components'
import useAudio from '../../components/UI/PlayerPodcast/components/useAudio'
import { MediaCard, LinearDeterminate, CardPodcast } from 'components/UI/'
import { setStep5, setStep4, setStep3, setStep2, setStep1, createStory } from '../../modules/story/actions'
import { useDebouncedCallback } from 'use-debounce'
import api from '../../api/stoty'
import { setGetChats } from '../../modules/chatCategory/actions'
import './index.scss'

const Home = () => {
  const [myLastStorys, setMylastStorys] = useState([])
  const [userOnlineSotirys, setUSerOnlineStorys] = useState([])
  const [anotherStorys, setAnotherStorys] = useState([])
  const [loading, setLoading] = useState(false)
  const [visibleStorys, setVisibleStorys] = useState(false)
  const history = useHistory()
  const dispatch = useDispatch()
  const { pathname } = useLocation()
  const { user } = useSelector(({ session }) => session)
  const { step1, step2, step3, step4, step5 } = useSelector(({ story }) => story)
  const { getChatsUpdate } = useSelector(({ chat }) => chat)
  const [audioElement, audioProps] = useAudio()
  const [srcAudio, setSrcAudio] = useState(null)
  const [play, setPlay] = useState(false)
  const { audioState } = useSelector(({ audio }) => audio)
  const [loadingStory, setLoadingStory] = useState(false)
  const [countStory, setCountStory] = useState(0)
  const [skip, setSkip] = useState(0)

  useEffect(() => {
    if (Math?.round(audioState?.time) === 3) {
      debouncedListen()
    }
  }, [audioState?.time])

  const executeScroll = ref => ref.current.scrollIntoView()

  const goTo = storyId => history.push(`/story/${storyId?.uuid}`)

  const getStoriesByType = (setStorys, type, storyGroup, skip = 0) => {
    api?.getStorys({
      id: user?.user?.uuid,
      type: type,
      storyGroup: storyGroup,
      limit: 20,
      skip: skip,
    })
      .then(({ data }) => setStorys(data?.stories))
      .catch(error => console.error(error))
      .finally(() => {
        setLoading(false)
      })
  }

  const getAnotherStorys = (type, skip = 0) => {
    api?.getStorys({
      id: user?.user?.uuid,
      type: type,
      storyGroup: 2,
      limit: 20,
      skip: skip,
    })
      .then(res => setAnotherStorys(prev => [...prev, ...res?.data?.stories]))
      .catch(error => console.error(error))
      .finally(() => {
        setSkip(prev => prev + 20)
        setLoadingStory(false)
      })
  }

  const getStoryCount = (type, skip = 0) => {
    api?.getStoryCount({
      id: user?.user?.uuid,
      type: type,
      storyGroup: 2,
      limit: 20,
      skip: skip,
    })
      .then(({ data }) => setCountStory(data?.count))
      .catch(error => console.error(error))
  }

  const getFullTypeStorys = type => {
    getStoriesByType(setMylastStorys, type, 0)
    getStoriesByType(setUSerOnlineStorys, type, 1)
  }

  const listenPodcast = id => {
    if (user?.accessKey) {
      api?.listenPodcastLogin(id, user?.accessKey)
        .catch(error => console.error(error))
    } else {
      api?.listenPodcastNoLogin(id)
        .catch(error => console.error(error))
    }
  }

  const debouncedListen = useDebouncedCallback(
    () => {
      listenPodcast(audioState?.podcast?.podcast?.uuid)
    }, 500
  )

  useEffect(() => {
    if (user?.user?.uuid) {
      if (pathname === '/' || pathname === '/sign-up/first-session') {
        dispatch(createStory({
          type: step5?.type,
          text: step1?.text,
          title: step2?.title,
          accessKey: user?.accessKey,
          hashtags: step4?.hashtags,
          imageUuid: step3?.imageUuid,
        })).then(res => {
          getFullTypeStorys(null)
          dispatch(setStep1(null))
          dispatch(setStep2(null))
          dispatch(setStep3(null))
          dispatch(setStep4(null))
          dispatch(setStep5(null))
        })
      }
    }
  }, [user?.user?.uuid, pathname])

  const scrollHandler = e => {
    if (e.target.scrollHeight - (e.target.scrollTop + window.innerHeight) < 400) {
      setLoadingStory(true)
    }
  }

  useEffect(() => {
    window?.addEventListener('scroll', scrollHandler, true)
    return function () {
      window.removeEventListener('scroll', scrollHandler, true)
    }
  }, [])

  useEffect(() => {
    if (pathname === '/troubled') {
      getFullTypeStorys(0)
      getAnotherStorys(0)
      getStoryCount(0)
    } else if (pathname === '/empowered') {
      getFullTypeStorys(1)
      getAnotherStorys(1)
      getStoryCount(1)
    } else {
      getAnotherStorys(null)
      getFullTypeStorys(null)
      getStoryCount(null)
    }
  }, [pathname])

  useEffect(() => {
    if (loadingStory && +anotherStorys?.length < countStory) {
      if (pathname === '/troubled') {
        getAnotherStorys(0, skip + 20)
      } else if (pathname === '/empowered') {
        getAnotherStorys(1, skip + 20)
      } else {
        getAnotherStorys(null, skip + 20)
      }
    }
  }, [loadingStory])

  useEffect(() => {
    if (getChatsUpdate) {
      getFullTypeStorys(null)
      dispatch(setGetChats(false))
    }
  }, [getChatsUpdate])

  useEffect(() => {
    if (myLastStorys?.length || userOnlineSotirys?.length || anotherStorys?.length) {
      setVisibleStorys(true)
    }
  }, [myLastStorys, userOnlineSotirys, anotherStorys])

  return (
    <Grid className='wrapperHomePage'>
      <div className='wrapperMenuMobile'>
        <Menu />
      </div>

      {loading && <LinearDeterminate visible />}

      <div className='wrapperStories'>
        {visibleStorys && (
          <ResponsiveMasonry columnsCountBreakPoints={{ 319: 1, 767: 2, 1279: 3 }}>
            <Masonry columnsCount={3} gutter={30}>
              {myLastStorys?.map(i => (
                <div key={i?.uuid} className='itemHoverEffect'>
                  <MediaCard goTo={goTo} data={i} />
                </div>
              ))}
              {userOnlineSotirys?.map(i => (
                <div key={i?.uuid} className='itemHoverEffect'>
                  <MediaCard goTo={goTo} data={i} />
                </div>
              ))}
              {anotherStorys?.map(i => (
                <div key={i?.uuid} className='itemHoverEffect'>
                  {i?.content === 1 ? (
                    <MediaCard goTo={goTo} data={i} />
                  ) : (
                    <CardPodcast
                      executeScroll={executeScroll}
                      setSrcAudio={setSrcAudio}
                      srcAudio={srcAudio}
                      audioElement={audioElement}
                      audioProps={audioProps}
                      data={i}
                      play={play}
                      setPlay={setPlay}
                      id={audioState?.src}
                    />
                  )}
                </div>
              ))}
            </Masonry>
          </ResponsiveMasonry>
        )}
      </div>
    </Grid>
  )
}

export default Home
